export default "/images/rupay.png";